"use client";

import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";

export function ThemeToggle() {
	const { resolvedTheme, setTheme } = useTheme();
	const [mounted, setMounted] = useState(false);

	useEffect(() => setMounted(true), []);

	if (!mounted) {
		return (
			<Button variant="outline" size="icon" aria-label="Toggle theme" disabled>
				<Sun aria-hidden="true" className="size-5" />
			</Button>
		);
	}

	return (
		<Button
			variant="outline"
			size="icon"
			aria-label={resolvedTheme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
			onClick={() => setTheme(resolvedTheme === "dark" ? "light" : "dark")}
		>
			<Sun aria-hidden="true" className="size-5 dark:hidden" />
			<Moon aria-hidden="true" className="hidden size-5 dark:block" />
		</Button>
	);
}
